import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UtilityService } from '../../../services/utility-service';
import {Title} from '@angular/platform-browser';
import {ChangeDetectorRef} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-trial-balance-result',
  templateUrl: './trial-balance-result.component.html',
  styleUrls: ['./trial-balance-result.component.scss']
})
export class TrialBalanceResultComponent implements OnInit {
  loanNumber: string;
  reportingPeriod: string;
  moneyTable: any[];
  stringTable: any[];
  mcols : any[];
  scols: any[];
  title = 'Trial Balance Results';

  constructor(private _route: ActivatedRoute, private _util: UtilityService, private titleService: Title,
              private cdr: ChangeDetectorRef) {
    this.fetchAndPopulate();
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.scols = [{field: 'label', header: ' '}, {field: 'userValue', header: 'Your Value'},
      {field: 'fmValue', header: 'Fannie Mae Value'}];
    this.mcols = [...this.scols, {field: 'diffValue', header: 'Difference'}];
    this.cdr.detectChanges();
  }

  fetchAndPopulate() {
    this._route.queryParams.subscribe((param) => {
      this.loanNumber = param.loanNumber;
      this.reportingPeriod = param.rptDate;
      const res = JSON.parse(atob(param.result));
      this.moneyTable = res.mTable;
      this.stringTable = res.sTable;
      this.stringTable.forEach((d) => {
        if (d.label === 'Payment Plan') {
          const userPlan = this._util.paymenetPlanById(d.userValue);
          d.userValue = userPlan.label;
          const fmPlan = this._util.paymenetPlanById(d.fmValue);
          d.fmValue = fmPlan.label;
        }
      });
    });
  }

}
